import React from 'react'
import Container from '../Container/Index'
import Title from '../Title/Index'
import ImageTag from '../ImageTag/Index'

const Values = {
      title: "Our Values",
      listitems : [
        {
          title: "Quality First",
          icon : "https://triverseadvertising.com/arsus_website/images/01.webp",
          description: "We uphold uncompromising standards to ensure superlative quality and strict adherence to government regulations."
        },
        {
          title: "Efficiency-Driven",
          icon : "https://triverseadvertising.com/arsus_website/images/02.webp",
          description: "Our modern manufacturing facility and streamlined processes enable speed, precision, and consistency at every step."
        },
        {
          title: "Integrity & Transparency",
          icon : "https://triverseadvertising.com/arsus_website/images/03.webp",
          description: "We build lasting partnerships and life-long trust through honesty, reliability, and responsible practices."
        },
        {
          title: "Customer-Centricity",
          icon : "https://triverseadvertising.com/arsus_website/images/04.webp",
          description: "Whether serving global brands or local labels, we are committed to delivering value and satisfaction."
        }
      ]
}

const VisionMission = ({Data}) => {
  return (
    <>
        <Container containerClass={'float-end'} _parentClass={'ourCorporate bigTitle'} sectionID={'ethos'}>
        <div className="col-12 float-start corporate_Bg_Image p-100 blueLayer">
            <div className='row'>
            <Title secondHeading={Data.title} _spanClass={'text-white'} firstHeading={Data.heading} _secondHeading={'text-white position-relative'}/>
                <div className='col-lg-8 col-sm-11 col-11 m-auto'>
                    <div className='row justify-content-between position-relative text-white'>
                    <div className='col-lg-5 col-sm-6 col-12' data-aos="fade-up"
          data-aos-offset="100"
          data-aos-duration="500"
          data-aos-once="true"
          data-aos-easing="ease-in-sine">
                    <Title secondHeading={Data.mission.title} _secondHeading={'text-white text-start'}  _class={'text-white text-start mb-1'}/>
                    <p dangerouslySetInnerHTML={{__html : Data.mission.content}} data-aos="fade-up"
          data-aos-offset="100"
          data-aos-duration="500"
          data-aos-once="true"
          data-aos-easing="ease-in-sine"/>
                        </div>
                        <div className='col-lg-5 col-sm-6 col-12'>
                        <Title secondHeading={Data.vision.title} _secondHeading={'text-white text-start'}  _class={'text-white text-start mb-2'}/>
                        <p dangerouslySetInnerHTML={{__html : Data.vision.content1}} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="col-12 float-start Vision py-lg-5 py-2">
           <Title firstHeading={Values.title} _class={'mb-4'} _spanClass={'text-white'}/>
            <div className='col-lg-11 col-12 m-auto'>                
            <ul data-aos="fade-up"
          data-aos-offset="100"
          data-aos-duration="500"
          data-aos-once="true"
          data-aos-easing="ease-in-sine" className='d-lg-flex justify-content-between d-inline'>
            {Values.listitems.map((items, index) => (
          <li key={index} className='mb-4 mb-lg-0'>
            <span className='spanIcon mb-3 mb-lg-1'><ImageTag ImagePath={items.icon} ImageWidth={60} ImageHeight={60}/></span>            
            <span>{items.title}</span>
            <p>{items.description}</p>
          </li>
        ))}
      </ul>                
            </div>
        </div>
        </Container>
       
    </>
  )
}

export default VisionMission